export default {
  summary: "",
  location: "",
  description: "",
  start: "",
  end: "",
  attendees: [{ email: "" }],
  reminders: {
    useDefault: false,
    overrides: [
      // { method: "email", minutes: 24 * 60 },
      { method: "popup", minutes: 5 },
    ],
  },
};
